module.exports = __webpack_public_path__ + "img/invoiceRepaire.3a47ad8b.png";